import React from 'react';
import { useTranslation } from 'react-i18next';

import { Utility } from '@swyftx/aviary/atoms/Typography';
import { CarBumper, Bank, Home } from '@swyftx/aviary/icons/outlined';
import { InfoCard } from '@swyftx/features/loans/components/EducationPage/common/InfoCard';

import { LoansSection } from '../common/LoansSection';

const LoansPutYourBitcoinToWork: React.FC = () => {
  const { t } = useTranslation('loans');
  const icons = [
    <Home
      key='home-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
    <CarBumper
      key='car-bumper-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
    <Bank
      key='bank-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
  ];

  return (
    <LoansSection
      header={{
        title: t('PutYourBitcoinToWork.heading.title'),
        description: t('PutYourBitcoinToWork.heading.description'),
      }}
      content={<InfoCard pageName='PutYourBitcoinToWork' icons={icons} />}
      footer={
        <Utility variant='caption' color='secondary'>
          {t('PutYourBitcoinToWork.Terms')}
        </Utility>
      }
    />
  );
};

LoansPutYourBitcoinToWork.displayName = 'LoansPutYourBitcoinToWork';

export { LoansPutYourBitcoinToWork };
